var map = {
	"./dt-forms.svg": "xpK1",
	"./dt-hours.svg": "XnYW",
	"./dt-ranking.svg": "Xy7E",
	"./dt.svg": "4dAk",
	"./eq-cash.svg": "eoUN",
	"./eq-printRecord.svg": "ARLV",
	"./eq-printTemplate.svg": "qu+0",
	"./eq-printer.svg": "eUJG",
	"./eq.svg": "SScB",
	"./example.svg": "OOLB",
	"./eye.svg": "4wdf",
	"./form.svg": "sTIr",
	"./home.svg": "U9Ws",
	"./login-mall.svg": "xzZT",
	"./marker.svg": "0+/s",
	"./meal-classes.svg": "tbbD",
	"./meal-dish.svg": "G7Ht",
	"./meal-menu.svg": "Ix0L",
	"./meal-period.svg": "8JkE",
	"./meal.svg": "FJ8J",
	"./oms-order.svg": "llrH",
	"./oms.svg": "zblz",
	"./password.svg": "QjmH",
	"./paymentMethod.svg": "BLdM",
	"./store-list.svg": "Lwy5",
	"./store.svg": "Lta+",
	"./table.svg": "oSYw",
	"./third-partyApplications.svg": "3eTw",
	"./total-today.svg": "le/7",
	"./total-week.svg": "csmh",
	"./total-yesterday.svg": "C15R",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-handbook.svg": "vo0t",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums-vps.svg": "0kg3",
	"./ums.svg": "J4x9",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 67